if (!customElements.get('product-specification')) {
  customElements.define(
    'product-specification',
    class productSpecification extends HTMLElement {
      constructor() {
        super();

        window.customUpdateProductSpecification = (url, optionValues) => {
          const params = [];
          params.push(`section_id=${this.dataset.sectionId}`);

          if (optionValues.length) {
            params.push(`option_values=${optionValues.join(',')}`);
          }

          const requestUrl = `${url}?${params.join('&')}`;

          fetch(requestUrl)
            .then((response) => response.text())
            .then((responseText) => {
              const html = new DOMParser().parseFromString(responseText, 'text/html');
              const newSection = html.querySelector(`#shopify-section-${this.dataset.sectionId} .collapsible-content`);
              const currentSection = document.querySelector(`#shopify-section-${this.dataset.sectionId} .collapsible-content`);
              if (newSection && currentSection) {
                currentSection.innerHTML = newSection.innerHTML;
              }
            });
        };
      }
    }
  );
}
